import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import CustomDropdown from '@components/CustomDropdown';
import { toastError } from '@components/Toast';

import { generateSampleDetailsParams } from '@features/filter/static/filterUtil';

import { handleFilterOfListPage } from '@store/actions/FilterAction';
import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import ApiClient from '@lib/apiClient';

import { changeDateFormat } from '@utils/Util';

import { BASE_URL } from '@/constants/constant';

const AssignSampleMember = ({ actionType, closeModal, selectedList }) => {
	const [userList, setUserList] = useState([]);
	const [inputData, setInputData] = useState([]);
	const [showError, setShowError] = useState(false);
	const [dateIndex, setDateIndex] = useState(null);
	const [memberIndex, setMemberIndex] = useState(null);
	const [selectedDate, setSelectedDate] = useState('');
	const filterfields = useSelector((store) => store.filterFieldStore);

	const dispatch = useDispatch();
	const { id } = useParams();

	useEffect(() => {
		let requestList = [];
		for (let item of selectedList) {
			let assignedTo = '';
			let assignedName = '';
			let requiredDate = '';
			if (actionType.toUpperCase() === 'PATTERN') {
				assignedTo = item?.patternActivityResponse?.assignedTo;
				assignedName = item?.patternActivityResponse?.assignedToName;
				requiredDate = item?.patternActivityResponse?.requiredDate;
			}
			if (actionType.toUpperCase() === 'CUTTING') {
				assignedTo = item?.cuttingActivityResponse?.assignedTo;
				assignedName = item?.cuttingActivityResponse?.assignedToName;
				requiredDate = item?.cuttingActivityResponse?.requiredDate;
			}
			if (actionType.toUpperCase() === 'SEWING') {
				assignedTo = item?.sewingActivityResponse?.assignedTo;
				assignedName = item?.sewingActivityResponse?.assignedToName;
				requiredDate = item?.sewingActivityResponse?.requiredDate;
			}
			requestList.push({
				sampleActivityDTO: {
					activityType: actionType.toUpperCase(),
					assignedTo: assignedTo,
					assignedName: assignedName,
					requiredDate: requiredDate
				},
				sampleItemId: item.id
			});
		}
		setInputData(requestList);
	}, []);

	useEffect(() => {
		let userType = 'PATTERN_MASTER';
		if (actionType === 'Cutting') {
			userType = 'CUTTING_MAN';
		} else if (actionType === 'Sewing') {
			userType = 'SEWING_MAN';
		}
		dispatch(openLoader());
		ApiClient.GET('getUserSuggestions', `?userType=${userType}`)
			.then(({ data }) => {
				let users = [];
				data.map((user) => users.push({ id: user.id, value: user.name }));
				setUserList(users);
				dispatch(closeLoader());
			})
			.catch(() => {
				toastError('Unable to fetch user list!');
				dispatch(closeLoader());
			});
	}, [actionType]);

	const validate = () => {
		let error = false;
		for (let item of selectedList) {
			if (getAssignedUser(item.id) === undefined || getRequiredDate(item.id) === '') {
				error = true;
				break;
			}
		}
		return error;
	};

	const handleSubmit = () => {
		if (validate()) {
			setShowError(true);
		} else {
			dispatch(openLoader());
			ApiClient.PUT(`${BASE_URL}/sample/request/${id}/update-item-activity`, inputData, '', true)
				.then(() => {
					setShowError(false);
					const { ...paramsData } = generateSampleDetailsParams(filterfields);
					dispatch(
						handleFilterOfListPage(
							{ type: 'sampleDetailsAction', idUrl: `${id}` },
							paramsData,
							false
						)
					);
					dispatch(closeLoader());
					closeModal();
				})
				.catch(() => {
					toastError('Unable to fetch user list!');
					dispatch(closeLoader());
				});
		}
	};

	const getAssignedUser = (id) => {
		let userName = '';
		for (let item of inputData) {
			if (parseInt(item.sampleItemId) === parseInt(id)) {
				userName = item.sampleActivityDTO.assignedName;
			}
		}
		return userName;
	};

	const getSelectedDate = (id) => {
		for (let item of inputData) {
			if (parseInt(item.sampleItemId) === parseInt(id)) {
				setSelectedDate(item.sampleActivityDTO.requiredDate);
			}
		}
	};

	const getRequiredDate = (id) => {
		let requiredDate = '';
		for (let item of inputData) {
			if (parseInt(item.sampleItemId) === parseInt(id)) {
				requiredDate = changeDateFormat(item.sampleActivityDTO.requiredDate, 'YYYY-MM-DD', 'DD MMM');
			}
		}
		if (requiredDate === 'Invalid date' || requiredDate === undefined) {
			return '';
		} else {
			return requiredDate;
		}
	};

	const setSelectedInput = (type, id, data) => {
		let cloneObj = [...inputData];
		for (let item of cloneObj) {
			if (type === 'user' && item.sampleItemId === id) {
				item.sampleActivityDTO.assignedTo = data.id;
				item.sampleActivityDTO.assignedName = data.value;
			}
			if (type === 'user' && !item?.sampleActivityDTO?.assignedTo) {
				item.sampleActivityDTO.assignedTo = data.id;
				item.sampleActivityDTO.assignedName = data.value;
			}
			if (type === 'date' && item.sampleItemId === id) {
				item.sampleActivityDTO.requiredDate = data;
			}
			if (type === 'date' && !item?.sampleActivityDTO?.requiredDate) {
				item.sampleActivityDTO.requiredDate = data;
			}
		}
		setInputData(cloneObj);
	};

	const handleDropDown = (value, id) => {
		if (value?.title) {
			setSelectedInput('user', id, value);
			setMemberIndex(null);
		}
	};

	const handleDate = (e, id) => {
		setSelectedInput('date', id, e.target.value);
		setDateIndex(false);
	};

	const renderDesignList = () => {
		return selectedList?.map((item) => {
			return (
				<tr key={`assign_item_${item.id}`}>
					<td className="design-details-column">
						<div className="d-flex align-items-center">
							<img src={item?.featureImageDocUrl} alt="" className="cell-img pr-2" />
							<span className="d-inline-block align-middle ml-1">
								{item?.referenceNumber} <br />
								<ul className="common-list-component mb-2">
									<li>{item?.market}</li>
									<li>{item?.category}</li>
								</ul>
							</span>
						</div>
					</td>
					<td>
						{getAssignedUser(item.id) !== undefined && memberIndex !== item.id ? (
							<span onClick={() => setMemberIndex(item.id)}>{getAssignedUser(item.id)}</span>
						) : (
							<span
								className={
									showError && getAssignedUser(item.id) === undefined
										? 'common-border-error'
										: ''
								}
							>
								<CustomDropdown
									type="addItem"
									title={'Assign Member'}
									onItemClick={(value) => handleDropDown(value, item.id)}
									items={userList}
									selectedItem={getAssignedUser(item.id)}
								/>
							</span>
						)}
					</td>
					<td className="date-column">
						{getRequiredDate(item.id) !== '' && dateIndex !== item.id ? (
							<span
								className="primary_bright_01"
								onClick={() => {
									getSelectedDate(item.id);
									setDateIndex(item.id);
								}}
							>
								{getRequiredDate(item.id)}
							</span>
						) : (
							<input
								type="date"
								className={
									showError && getRequiredDate(item.id) === '' ? 'common-border-error' : ''
								}
								value={selectedDate}
								onChange={(e) => setSelectedDate(e.target.value)}
								name="date"
								onBlur={(e) => handleDate(e, item.id)}
							/>
						)}
					</td>
				</tr>
			);
		});
	};

	return (
		<Modal show={true} onHide={closeModal} backdrop="static" className="width-720-modal">
			<div className="common-popup assign-pattern-master-popup shadow-24dp">
				<div className="common-popup-header d-flex justify-content-between">
					<div className="popup-tilte">
						<h3 className="semibold-16 mb-0">Assign {actionType.toLowerCase()} master</h3>
					</div>
					<div className="close-btn">
						<img
							onClick={closeModal}
							src={`${process.env.PUBLIC_URL}/icons/close.svg`}
							alt="close"
						/>
					</div>
				</div>
				<Modal.Body>
					<div className="common-popup-body scollable-modal-body scroll-y-label pb-0">
						<div className="sample-details-table">
							<table className="table with-border">
								<thead>
									<tr>
										<th className="design-details-column">Designs</th>
										<th className="sample-details-column">{actionType} master</th>
										<th className="date-column">Delivery date</th>
									</tr>
								</thead>
								<tbody>{renderDesignList()}</tbody>
							</table>
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<div className="footer-buttons text-right">
						<button className="button gray-outline size32" onClick={closeModal}>
							<span className="gray_dark_02">Cancel</span>
						</button>
						<button onClick={handleSubmit} className="button size32 ml-2">
							Submit
						</button>
					</div>
				</Modal.Footer>
			</div>
		</Modal>
	);
};

export default AssignSampleMember;
